import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const allowedRoutes = [
	/^\/$/,
	/^\/home$/,
	/^\/[^/]+$/,
	/^\/property-details\/[^/]+$/,
	/^\/contact-us$/,
	/^\/privacy-policy$/,
	/^\/about-us$/,
	/^\/our-services$/,
	/^\/author\/[^/]+$/,
	/^\/blog-grid$/,
	/^\/blog-detail\/[^/]+$/,
];

const Website = () => {
	const { pathname } = useLocation();

	const shouldRenderSchema =
		allowedRoutes.some((pattern) => pattern.test(pathname)) && pathname !== "/404";

	if (!shouldRenderSchema) {
		return null;
	}

	// Generate dynamic schema URL based on current pathname
	const baseUrl = "https://askmerealty.in";
	const currentUrl = pathname === "/" ? baseUrl + "/" : baseUrl + pathname;

	const schema = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: "AskMe Realty",
		url: currentUrl,
		potentialAction: {
			"@type": "SearchAction",
			target: {
				"@type": "EntryPoint",
				urlTemplate: "https://askmerealty.in/search?q={search_term_string}",
			},
			"query-input": "required name=search_term_string",
		},
	};

	const jsonLd = JSON.stringify(schema);

	return (
		<Helmet>
			<script id="website-schema" type="application/ld+json">{jsonLd}</script>
		</Helmet>
	);
};

export default Website;